import { useEffect, useRef } from 'react'

export function MagneticCursor({ reducedMotion = false }) {
  const cursorRef = useRef(null)

  useEffect(() => {
    if (reducedMotion || !window.matchMedia('(pointer: fine)').matches) return undefined

    const target = { x: window.innerWidth / 2, y: window.innerHeight / 2 }
    const current = { x: target.x, y: target.y }
    let frame = 0

    const onPointerMove = (event) => {
      target.x = event.clientX
      target.y = event.clientY
      document.documentElement.style.setProperty('--pointer-x', `${(event.clientX / window.innerWidth - 0.5).toFixed(4)}`)
      document.documentElement.style.setProperty('--pointer-y', `${(event.clientY / window.innerHeight - 0.5).toFixed(4)}`)
    }

    const animate = (time) => {
      current.x += (target.x - current.x) * 0.12
      current.y += (target.y - current.y) * 0.12
      const breath = 1 + Math.sin(time / 1300) * 0.045
      if (cursorRef.current) {
        cursorRef.current.style.transform = `translate3d(${current.x}px, ${current.y}px, 0) translate(-50%, -50%) scale(${breath})`
      }
      frame = requestAnimationFrame(animate)
    }

    window.addEventListener('pointermove', onPointerMove)
    frame = requestAnimationFrame(animate)

    return () => {
      cancelAnimationFrame(frame)
      window.removeEventListener('pointermove', onPointerMove)
      document.documentElement.style.removeProperty('--pointer-x')
      document.documentElement.style.removeProperty('--pointer-y')
    }
  }, [reducedMotion])

  return <div ref={cursorRef} className="magnetic-cursor" aria-hidden="true" />
}

export function MagneticButton({ href, children, className = '', external = false }) {
  const ref = useRef(null)

  useEffect(() => {
    const element = ref.current
    if (!element || !window.matchMedia('(pointer: fine)').matches) return undefined

    const reset = () => {
      element.style.transform = 'translate3d(0, 0, 0)'
    }
    const move = (event) => {
      const rect = element.getBoundingClientRect()
      const dx = event.clientX - (rect.left + rect.width / 2)
      const dy = event.clientY - (rect.top + rect.height / 2)
      element.style.transform = `translate3d(${Math.max(-10, Math.min(10, dx * 0.18))}px, ${Math.max(-10, Math.min(10, dy * 0.18))}px, 0) scale(1.025)`
    }

    element.addEventListener('pointermove', move)
    element.addEventListener('pointerleave', reset)
    return () => {
      element.removeEventListener('pointermove', move)
      element.removeEventListener('pointerleave', reset)
    }
  }, [])

  return (
    <a
      ref={ref}
      className={`magnetic-button ${className}`}
      href={href}
      target={external ? '_blank' : undefined}
      rel={external ? 'noreferrer' : undefined}
    >
      <span>{children}</span>
    </a>
  )
}
